module.exports = __webpack_public_path__ + "static/media/mg.fba42999.svg";